import * as React from 'react';
import './Footer.css';

export class Footer extends React.PureComponent {

    render() {
        return (
            <footer data-testid="footer" className="m-footer t-accent-dark" role="contentinfo">
                <div className="l-content-container">
                    <div className="l-columns l-columns--1-medium l-columns--1-large m-footer__lists">
                        <div className="l-columns__column m-footer__group m-footer__group--inline">
                            <ul className="a-list-plain m-footer__list m-footer__list--legal">
                                <li><a href="http://www.aviva.ie/accessibility/">About our website</a></li>
                                <li><a href="http://www.aviva.ie/privacy/">Privacy Policy</a></li>
                                <li><a href="http://www.aviva.ie/terms/">Terms and Conditions</a></li>
                                <li><a href="http://www.aviva.ie/sitemap/">Sitemap</a></li>
                                <li><a href="http://www.aviva.ie/cookie-policy/">Cookie Policy</a></li>
                            </ul>
                        </div>
                        <div className="a-list-plain m-footer__list m-footer__list--copyright">
                            <span>&copy; 2025 Aviva Ireland</span>
                        </div>
                        <p style={{fontSize: '12pt', lineHeight: '24px'}}>
                            As Aviva Driving School is not a financial service, it is not regulated
                            by the Central Bank.
                        </p>
                    </div>
                </div>
            </footer>
        );
    }
}